<template>
  <Dialog
    v-model="dialog"
    :title="$t('passwordRenewal.thankYouTitle')"
    left-header-icon="icons/confetti.svg"
    header-type="information"
  >
    <template #text>
      <div class="mb-8 mb-md-6">
        {{ $t('passwordRenewal.thankYouSubtitle') }}
      </div>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'PasswordRenewedDialog',
  computed: {
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'thankYouForRenewal';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.gtmPush({ event: 'notification_show', 'notification.type': 'passwordRenewed' });
      }
    }
  }
};
</script>
